import clsx from 'clsx';
import type { RecipientResponse } from '@shared/api/rest/recipients';
import { ColorsEnum, Icon, Text } from '@shared/widgets';
import ChevronIcon from '@assets/icons/chevron.svg';

interface RecipientDetailsProps {
  isShowRecipientDetails?: boolean;
  toggleDetails: () => void;
  recipient: RecipientResponse | null;
}

export const RecipientDetails = (props: RecipientDetailsProps) => {
  return (
    <div className='flex flex-col w-full mt-3'>
      <div className='flex gap-2 cursor-pointer' onClick={props.toggleDetails}>
        <Text>Recipient's details</Text>
        <Icon icon={<ChevronIcon />} className={clsx('-rotate-90 transition ease-out', props.isShowRecipientDetails && '!rotate-90')} />
      </div>
      {props.isShowRecipientDetails && props.recipient && (
        <div className='flex gap-10 mt-3'>
          <div className='flex flex-col'>
            <Text size='sm' color={ColorsEnum.Secondary}>
              IBAN
            </Text>
            <Text weight='semibold' size='sm'>
              {props.recipient.iban}
            </Text>
          </div>
          <div className='flex flex-col'>
            <Text size='sm' color={ColorsEnum.Secondary}>
              Bank name
            </Text>
            <Text weight='semibold' size='sm'>
              {props.recipient.bankName}
            </Text>
          </div>
          <div className='flex flex-col'>
            <Text size='sm' color={ColorsEnum.Secondary}>
              BIC / SWIFT Code
            </Text>
            <Text weight='semibold' size='sm'>
              {props.recipient.bic}
            </Text>
          </div>
          {props.recipient.firstName && (
            <div className='flex flex-col'>
              <Text size='sm' color={ColorsEnum.Secondary}>
                First name
              </Text>
              <Text weight='semibold' size='sm'>
                {props.recipient.firstName}
              </Text>
            </div>
          )}
          {props.recipient.lastName && (
            <div className='flex flex-col'>
              <Text size='sm' color={ColorsEnum.Secondary}>
                Last name
              </Text>
              <Text weight='semibold' size='sm'>
                {props.recipient.lastName}
              </Text>
            </div>
          )}
          {props.recipient.companyName && (
            <div className='flex flex-col'>
              <Text size='sm' color={ColorsEnum.Secondary}>
                Company name
              </Text>
              <Text weight='semibold' size='sm'>
                {props.recipient.companyName}
              </Text>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
